import { render } from "./ViewNotificationContentPage.vue?vue&type=template&id=362bbbe6&ts=true"
import script from "./ViewNotificationContentPage.vue?vue&type=script&lang=ts"
export * from "./ViewNotificationContentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__